import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { injectParams } from 'ngxtension/inject-params';
import { map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/shared/services/auth/auth_service';
import { GrowthbookService } from 'src/shared/services/growthbook/growthbook.service';
import { MixpanelService } from 'src/shared/services/mix-panel.service/mix-panel.service';
import { RightImagePageWrapperComponent } from '../../design/rightimagepagewrapper/rightimagepagewrapper.component';
import { SqaureImageGrid } from '../../design/squareimagegrid/squareimagegrid.component';
import { SquareImageGridConfig, SquareImageGridItem } from '../../design/squareimagegrid/squareimagegrid.interface';

@Component({
  selector: 'app-tenants',
  templateUrl: './tenants.component.html',
  imports: [RightImagePageWrapperComponent, SqaureImageGrid],
})
export class TenantsComponent implements OnInit {
  redirectUrl = injectParams('redirectUrl');
  urlTenant = injectParams('insurer');
  environment = environment;
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private authenticationService = inject(AuthenticationService);
  private mixPanelService = inject(MixpanelService);
  private growthbookService = inject(GrowthbookService);
  private destroyRef = inject(DestroyRef);

  isRegister = toSignal(this.route.params.pipe(map((params: any) => params.redirectUrl === 'register')));

  gridConfig: SquareImageGridConfig = {
    maxcolumns: 2,
    items: [],
  };

  async ngOnInit() {
    await this.growthbookService.whenReady(3000);
    this.gridConfig.items = this.getGridItems();
    this.route.params.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      console.log(params);
    });
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      switch (params['source']) {
        case 'AFIHUB':
          this.authenticationService.setTenant('animalfriends');
          this.router.navigate(['register']);
          break;
        case 'PURELY':
          this.authenticationService.setTenant('purelypets');
          this.router.navigate(['register']);
          break;
        case 'PETDATABASE':
          this.authenticationService.setTenant('pet-database');
          this.router.navigate(['login']);
          break;
      }
    });
    this.mixPanelService.track('tenant.list');
    const tenantParam = this.urlTenant();
    if (tenantParam) {
      this.redirectToTenant(tenantParam);
    }
  }

  getGridItems() {
    const cruftsEnabled = this.growthbookService.featureValue('cruftsclub_enabled', false);
    const tenants = environment.tenants
      .filter((tenant) => tenant.name !== 'Joii' && tenant.allowLogin && (!this.isRegister() || tenant.allowCreation))
      .map((tenant) => {
        return {
          id: tenant.friendly_id,
          dataautomationid: 'tenant',
          title: tenant.name,
          image: tenant.icon,
          subtitle: tenant.subtitle,
        };
      });
    if (cruftsEnabled) {
      tenants.push({
        id: 'cruftsclub',
        dataautomationid: 'tenant',
        title: 'Crufts Club',
        image: 'assets/svgs/cruftsclublogo.svg',
        subtitle: 'Crufts Club',
      });
    }
    return tenants;
  }

  redirectToTenant(urlTenant: string) {
    if (!urlTenant) {
      return;
    }
    const tenant = environment.tenants.find((d) => d.friendly_id == urlTenant);
    if (tenant) {
      this.authenticationService.setTenant(tenant.friendly_id);
      this.router.navigate([`/${this.redirectUrl() || 'login'}`], { queryParamsHandling: 'preserve' });
    }
  }

  linkClicked(item: SquareImageGridItem) {
    const isCruftsClub = item.id === 'cruftsclub';
    const id = isCruftsClub ? 'joii' : item.id;
    this.authenticationService.setTenant(id);
    if (isCruftsClub) {
      this.authenticationService.setEntitlementProvider('cruftsclub');
    } else {
      this.authenticationService.clearEntitlementProvider();
    }
    this.mixPanelService.track('tenant.selected', {
      business: id,
      entitlement: isCruftsClub ? 'cruftsclub' : undefined,
    });

    const route = (this.redirectUrl() || 'login') + (isCruftsClub ? '/cruftsclub' : '');
    this.router.navigate([`/${route}`], {
      queryParamsHandling: 'preserve',
    });
  }

  defaultTenantClicked() {
    var tenant = environment.tenants.find((x) => x.friendly_id == 'joii');
    this.authenticationService.setTenant(tenant?.id ?? '');
    this.router.navigate([`/${this.redirectUrl() || 'login'}`], { queryParamsHandling: 'preserve' });
  }
}
